import { Suspense } from "react";
import { RouterProvider } from "react-router-dom";
import routes from "./Routes/MainRoutes";
import Loading from "./components/Loading";
import "./utils/Language/Language";
import 'number-to-text/converters/en-us'
import 'number-to-text/converters/id'
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <div className="app">
      <ToastContainer position="top-right" autoClose={1500} />
      <Suspense fallback={<Loading />}>
        <RouterProvider router={routes} />
      </Suspense>
    </div>
  );
}

export default App;
